import { PROJECT_NAME } from '@/config/const';

export default {
  computed: {
    isShow() {
      return this.$store.getters['loginAlert/isShow'];
    }
  },
  methods: {
    openLoginModal() {
      this.$swal.fire({
        title: '新規登録/ログイン確認',
        text: `${PROJECT_NAME}をご利用いただくにはログインが必要です。\n新規登録/ログインをお願いいたします。\n新規登録/ログインに進みますか？`,
        showCancelButton: true,
        reverseButtons: true,
        cancelButtonText: 'キャンセル',
        confirmButtonText: 'ログイン画面へ',
        customClass: {
          container: 'withee-alert'
        }
      })
        .then((result) => {
          if (result.isConfirmed) {
            const callback = encodeURIComponent(document.location.href);
            this.$router.push({ path: '/login', query: { callback: callback } });
          }
          this.$store.commit('loginAlert/close');
        });
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.openLoginModal();
      }
    }
  }
};
